// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button, Segment } from 'semantic-ui-react';
import _ from 'lodash';
// local
// libs
import { _val } from 'app/lib/helper';
// actions
import { deinit, closeModal } from 'app/redux/actions/patient/disableModal';
// Views
import Notification from 'app/ui/commons/notification/Notification';
import DropdownPatientCylinders from 'app/ui/pages/patients/DropdownPatientCylinders';

class DisablePatientModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patient: null,
            form: this.initForm({}),
        };
    }

    componentWillReceiveProps(nextProps) {
        const { data } = nextProps.disablePatientModal;
        if (data) {
            this.setState({
                patient: data,
                form: this.initForm({}),
            });
        }
    }

    componentWillUnmount = () => this.onClose();

    initForm(data) {
        return {
            sealedCylinders: _val(data.sealedCylinders, 0),
        };
    }

    onClose = () => this.props.dispatch(closeModal());

    onSubmit = () => {
        const { patient, form } = this.state;
        this.props.dispatch(deinit(patient.id, form, this.props.disablePatientModal.onSuccessCallback));
    };

    handleChange = value => {
        const form = _.set(this.state.form, 'sealedCylinders', value);
        this.setState({ form });
    };

    render() {
        const { form, patient } = this.state;
        const { isOpened, loading, error } = this.props.disablePatientModal;
        return (
            <Modal size="small" open={isOpened} onClose={this.onClose}>
                <Segment vertical loading={loading}>
                    {error ? <Notification message={error.errors} isError /> : null}
                    <Modal.Content className="text-center">
                        {patient && (
                            <div className="no-margin">
                                Você tem certeza que deseja <b>DESATIVAR</b> o paciente <span className="uppercase">{patient.name}?</span>
                            </div>
                        )}
                        <div>O histórico do paciente será arquivado e os dados após a desativação não serão mais considerados.</div>
                        <div className="margin-2x">
                            Por favor, informe o número cilindros <b>LACRADOS</b>:
                            {patient && (
                                <div style={{ display: 'inline-block', marginLeft: '8px' }}>
                                    <DropdownPatientCylinders patientId={patient.id} value={form.sealedCylinders} onChange={this.handleChange} />
                                </div>
                            )}
                        </div>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button content="Cancelar" onClick={this.onClose} />
                        <Button className="highlight" content="Confirmar" onClick={this.onSubmit} />
                    </Modal.Actions>
                </Segment>
            </Modal>
        );
    }
}

DisablePatientModal.propTypes = {
    dispatch: PropTypes.func,
    disablePatientModal: PropTypes.object,
};

const mapStateToProps = state => ({
    disablePatientModal: state.disablePatientModal,
});
export default connect(mapStateToProps)(DisablePatientModal);
